"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.INSURANCES_ENDPOINT = {
    getIndex: '/insurances/{{version}}/insurances?userUuid={{userUuid}}',
    postNewInsurance: '/insurances/{{version}}/users/{{userUuid}}/insurances/{{annualInsuranceUuid}}',
    deleteAutorenewInsurance: '/insurances/{{version}}/users/{{userUuid}}/insurances/{{annualInsuranceUuid}}',
};
